import React, { memo, useCallback, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { MVRYardstik } from 'src/components/mvr/MVRYardstik'
import { MVRManualUpload } from 'src/components/mvr/MVRManualUploadForm'
import { SecureWrapper } from '../layout/SecureWrapper'
import { MVRCollectDataStep } from 'src/interfaces/collectData'
import { MVRSelectOption } from './MVRSelectOption'
import { MVROption, MVROptionType } from './types'
import { yardstikOption, manualOption, skipOption } from './constants'

const MVRComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as MVRCollectDataStep

  const [selectedOptionType, setSelectedOptionType] = useState<MVROptionType | undefined>(undefined)

  const options = useMemo(() => {
    const res: MVROption[] = []

    if (currentStep.metadata?.enableYardstik) {
      res.push(yardstikOption)
    }

    if (currentStep.metadata?.enableManualUpload) {
      res.push(manualOption)
    }

    if (currentStep.optional) {
      res.push(skipOption)
    }

    return res
  }, [currentStep.metadata, currentStep.optional])

  const selectedOption = useMemo(() => {
    if (options.length === 1) {
      return options[0].value
    }

    return selectedOptionType
  }, [options, selectedOptionType])

  const handleBackToMainPage = useCallback(() => {
    setSelectedOptionType(undefined)
  }, [])

  return (
    <SecureWrapper
      onBack={!!selectedOption && options.length > 1 ? handleBackToMainPage : undefined}
    >
      {(!selectedOption || selectedOption === 'skip') && (
        <MVRSelectOption
          options={options}
          selectedOption={selectedOption}
          onSelect={setSelectedOptionType}
        />
      )}
      {selectedOption === 'yardstik' && <MVRYardstik />}
      {selectedOption === 'manual' && (
        <MVRManualUpload
          hideStepsCounter={options.length > 1}
          isYardstikEnabled={options.some((item) => item.value === 'yardstik')}
        />
      )}
    </SecureWrapper>
  )
}

export const MVR = memo(MVRComponent)
